import { render } from "./Menu.vue?vue&type=template&id=fda733de&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=fda733de&lang=scss&scoped=true"

import exportComponent from "/opt/cah/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fda733de"]])

export default __exports__